




















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { sleep } from '@ivy/fts/utils'

@Component
export default class QuestionDetail extends Vue {
  @Prop() info: any
  @Prop() index: number
  @Prop() audioStop: boolean = false
  isPlay: boolean = false
  curIndex: number = null
  @Watch('audioStop')
  watchAudio(val) {
    if (val && this.isPlay) {
      this.$nextTick()
      let audio: any = this.$refs.audio
      audio.pause()
    }
  }
  get questionType() {
    if (this.info.item_type === 'Foundational Reading') {
      if (this.info.quiz.stem_image) {
        return 'image_audio'
      } else {
        return 'audio'
      }
    } else if (['2-sent', 'Native'].includes(this.info.item_type)) {
      return 'text'
    } else if (this.info.item_type === 'Picture') {
      return 'image'
    }
    return ''
  }
  audioBtn() {
    this.isPlay = true
    let audio: any = this.$refs.audio
    setTimeout(() => {
      audio.play()
    }, 10)
    this.audioStop = false
    audio.addEventListener(
      'ended',
      () => {
        this.isPlay = false
      },
      false
    )
  }
  choose(id, name, index) {
    this.curIndex = index
    this.audioStop = false
    this.$emit('chooseAnswer', { id, name })
  }
}
